module.exports = __webpack_public_path__ + "media/virtual-gallery/Testimonial-d4d434c1.jpg";